<template>
  <div class="main-content main-conent-maxheight main-content-rows page-home">
    <div class="home-head">
      <div class="title">农作物病虫害自动监测预警平台</div>
      <n-time></n-time>
      <div v-if="!isFullScreen" class="ctrls">
        <i class="el-icon-full-screen" @click="fullScreen"></i>
      </div>
    </div>

    <div class="main-rows">
      <div class="main-col main-left">
        <tele :dev-key="site.devices.lamp"></tele>
      </div>

      <div class="main-col main-body">
        <!-- <tranisition name="fade" style="width: 100%;height: 100%;">

        </tranisition> -->
        <div class="device-map-wrap" style="height: 67%;">
          <n-map :dev-key="site.devices.lamp"></n-map>
        </div>

        <card style="height: 33%;" direction="row">
          <solid :code="site.devices.solid"></solid>
        </card>
      </div>

      <div class="main-col main-right">
        <mete :weather-key="site.devices.weather"></mete>
      </div>
    </div>

    <side-menu @site-change="siteChange"></side-menu>
  </div>
</template>

<script>
import NTime from '../components/time'
import SideMenu from '../components/SideMenu'
import NMap from './components/map'
import Tele from './components/tele/index'
import Mete from './components/mete/index'
import Solid from './components/solid/index'
import Card from './components/card'

export default {
  components: { NTime, SideMenu, Tele, NMap, Mete, Card, Solid },
  name: 'Home',
  data() {
    return {
      centerType: 'map',
      clone: null,
      isFullScreen: false,
      site: { devices: { solid: '', lamp: '', weather: '', spore: '' } }
    }
  },
  mounted() {
    this.$el.onfullscreenchange = this.exitFullScreen
  },
  methods: {
    fullScreen() {
      this.$el.requestFullscreen()
    },
    exitFullScreen() {
      this.isFullScreen = !this.isFullScreen
    },
    siteChange(site) {
      this.site = site
    }
  }
}
</script>

<style lang="scss">
.page-home {
  background-image: url('~@/assets/images/dashboard-bg.jpg');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .home-map-btn-group {
    position: absolute;
    top: 8px;
    left: 80px;
    z-index: 100;
    .el-button {
      background-color: rgba(51, 53, 56, 1);
      border: #656565;
      &.is-disabled {
        background-color: rgba(51, 53, 56, 0.7);
        color: #9aa8d4;
      }
    }
  }
  .device-map-wrap {
    position: relative;
    padding-bottom: 40px;
    box-sizing: border-box;
  }
  .home-head {
    height: 110px;
    width: 90%;
    text-align: center;
    background-image: url('~@/assets/images/title-bg.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .title {
      font-size: 32px;
      line-height: 100px;
      text-align: center;
    }
    .time {
      position: absolute;
      right: 20px;
      top: 60px;
    }
    .ctrls {
      position: absolute;
      right: 20px;
      top: 4px;
      font-size: 1.2rem;
      color: rgba(0, 182, 252, 0.6);
      cursor: pointer;
    }
  }
  .main-col {
    margin: 0 20px;
    .home-card:not(:last-child) {
      // margin-bottom: 40px;
    }
  }
  .el-table {
    border: none;
    box-shadow: none;
  }
  .main-rows {
    height: calc(100% - 152px);
    width: 90%;
    display: flex;
    flex-direction: row;
  }
  .main-left,
  .main-right,
  .main-body {
    display: flex;
    flex-direction: column;
  }
  .main-left,
  .main-right {
    // flex: 1;
    width: 25%;
  }
  .main-body {
    flex: 2;
  }
  .device-picker {
    position: absolute;
    top: 8px;
    right: 20px;
    line-height: 24px;
    .el-input__inner {
      background-color: rgba(51, 53, 56, 0.5);
      border-color: #656565;
      color: #f3f1f1;
    }
    &.left {
      left: 20px;
      right: auto;
    }
  }
}
.device-picker__popper {
  background-color: #333538;
  border-color: #656565;
  .el-select-dropdown__item {
    color: #9aa8d4;
    &.selected {
      background-color: #656565;
      color: #fff;
    }
    &.hover {
      background-color: #656565;
    }
  }
  .popper__arrow {
    border-bottom-color: #656565 !important;
    &::after {
      border-bottom-color: #333538 !important;
    }
  }
}
</style>
